import { useTranslation } from "react-i18next";
import { Select } from "@radix-ui/themes";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <Select.Root
      value={i18n.language.startsWith("fr") ? "fr" : "en"}
      onValueChange={(value) => i18n.changeLanguage(value)}
    >
      <Select.Trigger variant="surface" />
      <Select.Content>
        {languages.map((lang) => (
          <Select.Item key={lang.code} value={lang.code}>
            {lang.label}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
}
